import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { IS_APP_VIBEHISTORY } from "../constants.js";
import { initFacebookPixel, trackFacebookPageView } from "./facebookPixel";

/**
 * Компонент-слушатель маршрутов для Meta (Facebook) Pixel.
 * На маунт инициализирует пиксель, а затем отправляет PageView при каждом изменении маршрута.
 * Работает только при флаге IS_APP_VIBEHISTORY (нужный домен), иначе ничего не делает.
 */
const AnalyticsRouterListener = () => {
  const location = useLocation();

  // Инициализация пикселя один раз при маунте
  useEffect(() => {
    if (!IS_APP_VIBEHISTORY) return;
    initFacebookPixel();
  }, []);

  // Отправка PageView при смене маршрута
  useEffect(() => {
    if (!IS_APP_VIBEHISTORY) return;
    trackFacebookPageView();
  }, [location.pathname, location.search, location.hash]);

  return null;
};

export default AnalyticsRouterListener;
